import styles from "./index.module.css";
import BigLogo from "./BIGLogo.png";

const primaryLinks = [
  { label: "Про спільноту", href: "https://profound-english.community/#community" },
  { label: "Викладачі", href: "https://profound-english.community/#teachers" },
  { label: "Клуби", href: "https://profound-english.community/#clubs" },
  { label: "Вартість", href: "https://profound-english.community/#teachers" },
];

const secondaryLinks = [
  { label: "Блог", href: "https://profound-english.community/%D0%B1%D0%BB%D0%BE%D0%B3/" },
  {
    label: "Часті питання",
    href: "https://profound-english.community/%D1%87%D0%B0%D1%81%D1%82%D1%96-%D0%BF%D0%B8%D1%82%D0%B0%D0%BD%D0%BD%D1%8F/",
  },
  {
    label: "Договір оферти",
    href: "https://profound-english.community/%D0%B4%D0%BE%D0%B3%D0%BE%D0%B2%D1%96%D1%80-%D0%BE%D1%84%D0%B5%D1%80%D1%82%D0%B8/",
  },
  {
    label: "Кредити",
    href: "https://intensive.profound-english.community/installment",
  },
];

function FacebookIcon() {
  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 23.9859 5.85094 30.6053 13.5 31.8056V20.625H9.4375V16H13.5V12.475C13.5 8.465 15.8888 6.25 19.5434 6.25C21.2934 6.25 23.125 6.5625 23.125 6.5625V10.5H21.1075C19.12 10.5 18.5 11.7334 18.5 13V16H22.9375L22.2281 20.625H18.5V31.8056C26.1491 30.6053 32 23.9859 32 16Z"
        fill="currentColor"
      />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 2.88125C20.275 2.88125 20.7813 2.9 22.4625 2.975C24.025 3.04375 24.8688 3.30625 25.4313 3.525C26.175 3.8125 26.7125 4.1625 27.2688 4.71875C27.8313 5.28125 28.175 5.8125 28.4625 6.55625C28.6813 7.11875 28.9438 7.96875 29.0125 9.525C29.0875 11.2125 29.1063 11.7188 29.1063 15.9875C29.1063 20.2625 29.0875 20.7688 29.0125 22.45C28.9438 24.0125 28.6813 24.8563 28.4625 25.4188C28.175 26.1625 27.825 26.7 27.2688 27.2563C26.7063 27.8188 26.175 28.1625 25.4313 28.45C24.8688 28.6688 24.0188 28.9313 22.4625 29C20.775 29.075 20.2688 29.0938 16 29.0938C11.725 29.0938 11.2188 29.075 9.5375 29C7.975 28.9313 7.13125 28.6688 6.56875 28.45C5.825 28.1625 5.2875 27.8125 4.73125 27.2563C4.16875 26.6938 3.825 26.1625 3.5375 25.4188C3.31875 24.8563 3.05625 24.0063 2.9875 22.45C2.9125 20.7625 2.89375 20.2563 2.89375 15.9875C2.89375 11.7125 2.9125 11.2063 2.9875 9.525C3.05625 7.9625 3.31875 7.11875 3.5375 6.55625C3.825 5.8125 4.175 5.275 4.73125 4.71875C5.29375 4.15625 5.825 3.8125 6.56875 3.525C7.13125 3.30625 7.98125 3.04375 9.5375 2.975C11.2188 2.9 11.725 2.88125 16 2.88125ZM16 0C11.6563 0 11.1125 0.01875 9.40625 0.09375C7.70625 0.16875 6.5375 0.44375 5.525 0.8375C4.46875 1.25 3.575 1.79375 2.6875 2.6875C1.79375 3.575 1.25 4.46875 0.8375 5.51875C0.44375 6.5375 0.16875 7.7 0.09375 9.4C0.01875 11.1125 0 11.6562 0 16C0 20.3438 0.01875 20.8875 0.09375 22.5938C0.16875 24.2938 0.44375 25.4625 0.8375 26.475C1.25 27.5313 1.79375 28.425 2.6875 29.3125C3.575 30.2 4.46875 30.75 5.51875 31.1562C6.5375 31.55 7.7 31.825 9.4 31.9C11.1063 31.975 11.65 31.9937 15.9938 31.9937C20.3375 31.9937 20.8813 31.975 22.5875 31.9C24.2875 31.825 25.4563 31.55 26.4688 31.1562C27.5188 30.75 28.4125 30.2 29.3 29.3125C30.1875 28.425 30.7375 27.5313 31.1438 26.4813C31.5375 25.4625 31.8125 24.3 31.8875 22.6C31.9625 20.8938 31.9813 20.35 31.9813 16.0063C31.9813 11.6625 31.9625 11.1188 31.8875 9.4125C31.8125 7.7125 31.5375 6.54375 31.1438 5.53125C30.75 4.46875 30.2063 3.575 29.3125 2.6875C28.425 1.8 27.5313 1.25 26.4813 0.84375C25.4625 0.45 24.3 0.175 22.6 0.1C20.8875 0.01875 20.3438 0 16 0Z"
        fill="currentColor"
      />
      <path
        d="M16 7.78125C11.4625 7.78125 7.78125 11.4625 7.78125 16C7.78125 20.5375 11.4625 24.2188 16 24.2188C20.5375 24.2188 24.2188 20.5375 24.2188 16C24.2188 11.4625 20.5375 7.78125 16 7.78125ZM16 21.3312C13.0563 21.3312 10.6687 18.9438 10.6687 16C10.6687 13.0563 13.0563 10.6687 16 10.6687C18.9438 10.6687 21.3312 13.0563 21.3312 16C21.3312 18.9438 18.9438 21.3312 16 21.3312Z"
        fill="currentColor"
      />
      <path
        d="M26.4625 7.45586C26.4625 8.51836 25.6 9.37461 24.5438 9.37461C23.4813 9.37461 22.625 8.51211 22.625 7.45586C22.625 6.39336 23.4875 5.53711 24.5438 5.53711C25.6 5.53711 26.4625 6.39961 26.4625 7.45586Z"
        fill="currentColor"
      />
    </svg>
  );
}

function TelegramIcon() {
  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM22.541 9.63184C21.9392 9.64244 21.0155 9.96341 16.5723 11.8115C15.016 12.4588 11.9055 13.7989 7.24121 15.8311C6.48394 16.1322 6.08692 16.4268 6.05078 16.7148C5.98144 17.268 6.77827 17.4399 7.78027 17.7656C8.5972 18.0312 9.69631 18.3421 10.2676 18.3545C10.7856 18.3656 11.3637 18.1521 12.002 17.7139C16.3569 14.7741 18.6069 13.287 18.751 13.2529C18.8506 13.2303 18.9895 13.202 19.083 13.2852C19.1758 13.3681 19.1671 13.5245 19.1572 13.5674C19.078 13.9052 14.9837 17.6293 14.748 17.874C13.8479 18.8089 12.8243 19.3811 14.4033 20.4219C15.7702 21.3226 16.5664 21.8972 17.9746 22.8203C18.8745 23.4102 19.5797 24.1098 20.5088 24.0244C20.9363 23.9851 21.3782 23.5834 21.6025 22.3848C22.1326 19.5511 23.1743 13.4108 23.415 10.8809C23.4361 10.6592 23.41 10.3755 23.3887 10.251C23.3674 10.1266 23.3225 9.94958 23.1611 9.81836C22.9696 9.66294 22.6735 9.62957 22.541 9.63184Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function Footer({ noFIre }) {
  return (
    <footer
      className={styles.footer + (noFIre ? " " + styles.noFire : "")}
      id="footer"
    >
      <div className={styles.container}>
        <div className={styles.content}>
          <nav className={styles.linkGroup} aria-label="Основні розділи">
            {primaryLinks.map((link) => (
              <a href={link.href} key={link.label}>
                {link.label}
              </a>
            ))}
          </nav>

          <nav className={styles.linkGroup} aria-label="Додаткові розділи">
            {secondaryLinks.map((link) => (
              <a href={link.href} key={link.label}>
                {link.label}
              </a>
            ))}
          </nav>

          <div className={styles.contacts}>
            <p>Місце провадження діяльності:</p>
            <p>28008 м. Олександрія, проспект Соборний 100/97</p>
            <a href="tel:+380997153540">+38 099 715 35 40</a>
            <div className={styles.socials} aria-label="Соціальні мережі">
              <a
                href="https://www.facebook.com/profile.php?id=100083769962258"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <FacebookIcon />
              </a>
              <a
                href="https://www.instagram.com/profoundenglishcommunity/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>
              <a
                href="https://t.me/profoundenglish"
                target="_blank"
                rel="noreferrer"
                aria-label="Telegram"
              >
                <TelegramIcon />
              </a>
            </div>
            <p className={styles.copy}>2026 © Profound. All rights reserved.</p>
          </div>
        </div>

        <img className={styles.bigLogo} src={BigLogo} alt="" aria-hidden />
      </div>
    </footer>
  );
}
